<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive">
    </router-view>
    <!-- 充值弹框 -->
    <TopUp />
    <!-- 邀请弹框 -->
    <InviteDialog />
  </div>
</template>

<script>
import createWebSocket from "@/utils/websocket";
import { mapActions } from 'vuex';
import TopUp from "./components/TopUp.vue";
import InviteDialog from "./components/InviteDialog";
export default {
  name: 'App',
  components: { TopUp, InviteDialog },
  mounted() {
    // 获取apollo配置，可以动态添加key获取相应的配置数据
    // 数据将被存储来 vuex 中 apolloConfig
    // 使用 vuex getters 获取 指定的配置数据
    this.getApolloConfig({
      keys: ['ai_clothing_type', 'model_options', 'ai_video']
    })
    window.updateCard = this.updateCard
    createWebSocket().getSocket()
  },
  methods: {
    ...mapActions(['updateTaskDetail', 'getApolloConfig']),
    updateCard(val) {

      this.updateTaskDetail(val)
    },
  }
}
</script>

<style>
body {
  height: 100%;
  width: 100%;
}

/* canvas {
  cursor: none !important;
} */

#app {
  width: 100%;
  height: 100%;
}
</style>
